import { useTheme, styled, Fab, } from "@mui/material";
import { StyleguideSavioColors, StyleguideSavioFonts } from "../../../../configuration/themeSettings";

export const StyledHotSpot = styled(Fab, {
    label: "bestview-hotspot-bom2",
})(({ theme }) => ({
    position: "absolute",
    width: "62px",
    height: "62px",
    fontSize: 27,
    fontWeight: StyleguideSavioFonts.bold,

    "&:hover": {
        color: StyleguideSavioColors.lightGrey,
        backgroundColor: StyleguideSavioColors.mainBlue + " !important",
        zIndex: "100000",
    },
}));

